import { render, staticRenderFns } from "./NoticeView.vue?vue&type=template&id=08f94bea"
import script from "./NoticeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports